import { render } from "./Home.vue?vue&type=template&id=08ceb6ab&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=08ceb6ab&scoped=true&lang=css"

import exportComponent from "/media/diego-oliveira/ssd/projetos/andamento-da-obra-blend-pituba/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ceb6ab"]])

export default __exports__